import React from 'react';
import Button from 'react-bootstrap/Button';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  hasNextPage
}) => {
  const windowSize = 5;
  const halfWindow = Math.floor(windowSize / 2);

  const getPageWindow = () => {
    let start = Math.max(currentPage - halfWindow, 1);
    let end = start + windowSize - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(end - windowSize + 1, 1);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const baseStyle = {
    backgroundColor: '#082430',
    color: '#fff',
    border: 'none'
  };

  const inactiveStyle = {
    ...baseStyle,
    opacity: 0.75
  };

  const activeStyle = {
    ...baseStyle,
    fontWeight: 'bold',
    opacity: 1
  };

  return (
    <div className="d-flex justify-content-center align-items-center flex-wrap mt-2">
      <Button
        size="sm"
        className="mx-1"
        disabled={currentPage === 1}
        style={inactiveStyle}
        onClick={() => onPageChange(currentPage - 1)}
      >
        ‹
      </Button>

      {getPageWindow().map((page) => (
        <Button
          key={page}
          size="sm"
          className="mx-1"
          style={page === currentPage ? activeStyle : inactiveStyle}
          onClick={() => onPageChange(page)}
        >
          {page}
        </Button>
      ))}

      <Button
        size="sm"
        className="mx-1"
        disabled={!hasNextPage}
        style={inactiveStyle}
        onClick={() => onPageChange(currentPage + 1)}
      >
        ›
      </Button>
    </div>
  );
};

export default Pagination;
